module.exports = __webpack_public_path__ + "static/media/StoredValue.a77da769.svg";